<!--
 * @Author: your name
 * @Date: 2021-05-25 13:56:48
 * @LastEditTime: 2021-05-28 14:10:23
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \szny-official-website\src\views\Information\index.vue
-->


<template>
  <div class="page-information">
    <Header  path='/information'></Header>
    <div class="information-banner"></div>
    <div class="information-describe">
      <div class="information-center">
        <div class="caption">新闻中心</div>
        <el-row :gutter="20" class="bottom20">
          <el-col :span="12">
              <div class="purple-item">
                  <el-row :gutter="20">
                      <el-col :span="10">
                          <img src="../../assets/Information/new1.png"/>
                      </el-col>
                      <el-col :span="14">
                        <div class="content">
                           <div class="title">双边气源保供应 造福百姓促发展——重庆公司来西线接驳工程顺利完工</div>
                           <div class="mark">2020年12月6日，经过为期两天的停气改造施工，重庆公司双福来西线管道接驳成功，此次接驳是重庆公司双福配气站扩容改造工程的重要起步环节，奠定了双福…</div>
                           <div class="more" @click="onMore(1)">了解更多 ></div>
                        </div>
                      </el-col>
                  </el-row>
              </div>
         </el-col>
         <el-col :span="12">
              <div class="purple-item">
                  <el-row :gutter="20">
                      <el-col :span="10">
                          <img src="../../assets/Information/new2.png"/>
                      </el-col>
                      <el-col :span="14">
                        <div class="content">
                           <div class="title">经营指标稳中有进  安全管理强化提升——重庆神州召开2021年第一季度…</div>
                           <div class="mark">2021年4月26日上午，重庆公司副总经理唐新兴陪同集团谭总、张总一行对团结湖大数据产业园进行考察调研，谭总明确指出，重庆公司须密切关注团结湖项目进度，确保天然气项目…</div>
                           <div class="more" @click="onMore(2)">了解更多 ></div>
                        </div>
                      </el-col>
                  </el-row>
              </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
              <div class="purple-item">
                  <el-row :gutter="20">
                      <el-col :span="10">
                          <img src="../../assets/Information/new3.png"/>
                      </el-col>
                      <el-col :span="14">
                        <div class="content">
                           <div class="title">余庆县龙溪镇天然气利用项目LNG储罐顺利完成吊装</div>
                           <div class="mark">1月23日，余庆县龙溪镇LNG气化站2台60m³LNG储罐及工艺附属设备全部顺利安装完成，成为龙溪镇供气工程项目建设又一里程碑</div>
                           <div class="more" @click="onMore(3)">了解更多 ></div>
                        </div>
                      </el-col>
                  </el-row>
              </div>
         </el-col>
         <el-col :span="12">
              <div class="purple-item">
                  <el-row :gutter="20">
                      <el-col :span="10">
                          <img src="../../assets/Information/new4.png"/>
                      </el-col>
                      <el-col :span="14">
                        <div class="content">
                           <div class="title">门站通气试运行   六景用户有福“气”——南宁神州燃气有限公司六景门…</div>
                           <div class="mark">9月10日上午10:00，南宁神州燃气有限公司六景门站内热闹非凡，中石化管道天然气六景接气工程通气试运行仪式在此隆重举行。仪式由神州能源集团股份有限公司总裁谭佐龙主持。广西燃气集团董事长、中石化广…</div>
                           <div class="more" @click="onMore(4)">了解更多 ></div>
                        </div>
                      </el-col>
                  </el-row>
              </div>
          </el-col>
        </el-row>
      </div>
    </div>
    
    <Footer></Footer>
  </div>

</template>
<script>
    import Header from '@/components/Header/index.vue'
  import Footer from '@/components/Footer/index.vue'
  import router from '@/router'
  import { MessageBox as MessageBoxPC} from 'element-ui';
  export default {
    components: {
      Header,
      Footer,
    },
    data() {
      return {

        columns:[
          {id:0,title:'2020',children:[
            {id:0,month:'1月',explain:'公司取得“ISO三体系认证证书。”'},
          ]},
          {id:1,title:'2019',children:[
            {id:0,month:'12月',explain:'“渝神缘物联网膜式燃气表”正式取得，型式批准证书。'},
            {id:1,month:'11月',explain:'公司获得重庆市“高新企业证书”'},
            {id:2,month:'6月',explain:'“渝神缘智能燃气管理平台2.0“正式上线'},
            {id:3,month:'5月',explain:'公司取得“防爆合格证”'},
            {id:4,month:'1月',explain:'渝神缘物联网膜式燃气表销量突破十万支'},
          ]},
          {id:2,title:'2018',children:[
            {id:0,month:'12月',explain:'公司取得“实用新型证书”'},
            {id:1,month:'1月',explain:'“渝神缘物联网膜式燃气表销量突破3万支'},

          ]},
          {id:3,title:'2017',children:[
            {id:0,month:'12月',explain:'第一台物联网表研发成功'},
            {id:1,month:'1月',explain:'“渝神缘智能燃气管理平台1.0”正式上线'},

          ]},
        ]
      }
    },
    methods:{
      /**
       * 点击跳转
      */
      jump (value) {
            console.log('value========',value)
        router.push({
            path: value,
          }).catch(err => {
            console.log(err)
          })
        
      },
      open() {
        MessageBoxPC.alert('023-68663505', '电话咨询', {
          confirmButtonText: '确定',
          
        }).catch((err)=>{
          console.log(err);
        });
      },

      onMore(newId){
        // console.log('newId=====',newId)
            this.$router.push({name: 'InformationDetail', params: {id: newId}});
        // router.push({
            
        //     path: '/informationDetail?id='+newId,
        // }).catch(err => {
        //     console.log(err)
        // })

      }


    }
  }
</script>
<style lang="sass">
  @import "./style.scss"
</style>
